export interface SkinDate {
    dateFIAF?: string | null,
    endDateFIAF?: string | null,
    useDate: string,
    empty: boolean,
    skinIntervalComplexes?: SkinIntervalComplex[] | null,
    txt: string
}

export interface SkinIntervalComplex {
    startInterval?: SkinInterval | null,
    endInterval?: SkinInterval | null,
}

export interface SkinInterval {
    date?: number | null
    dateTxt?: string | null
    dateYear?: string | null
    unit?: any // DateUnit | null
    yearAsNumber?: number | null
}

export enum SkinDateFormat {
    DATE,
    TEXT,
    NEGATIVE
}